export default urlQueryParams =>
    Object.entries(urlQueryParams).reduce((acc, [key, value]) => {
        /** remove utm_ like query params which are
         * added automatically after redirecting from gmail */
        const noGmailParams = !key.includes('utm_');
        const noNullParams = !!value;
        noNullParams && noGmailParams && (acc[key] = value);
        return acc;
    }, {});
